import * as React from 'react'
import { useNavigate } from 'react-router-dom'
import { styled } from 'next-yak'

import { NewsCard as DuvetNewsCard, type NewsCardProps } from '@ulule/duvet/NewsCard.tsx'
import * as hooks from '@owl-nest/hooks'
import * as plume from '@ulule/owl-kit-components/next'

import { useNavigation } from '../../../../hooks/useNavigation'
import { PATHS } from '../../../../paths'

export function NewsCard(props: Omit<NewsCardProps, 'link'>): React.ReactNode {
  const navigate = useNavigate()
  const navigation = useNavigation()

  const localPathToNews = navigation.pathTo({
    path: PATHS.NEWS_PERMALINK,
    params: { slug: `${props.news.slug}-${props.news.id}` },
  })

  const linkClickHandler = hooks.useLinkClickHandler({
    navigate: () => navigate(localPathToNews),
  })

  return (
    <StyledNewsCard
      {...props}
      link={{
        href: `${props.project.absolute_url}${localPathToNews.pathname.slice(1)}`,
        onClick: linkClickHandler,
      }}
    />
  )
}

const StyledNewsCard = styled(DuvetNewsCard)`
  margin: 30px 0;

  ${plume.Tooltip} {
    z-index: ${plume.ZINDEX.DRAWER};
  }

  &::before {
    content: '';
    position: absolute;
    z-index: -1;
    top: 0px;
    left: 50%;
    bottom: -40px;
    border: 1px dashed ${plume.COLORS.PRIMARY_GREY_500};
    background: ${plume.COLORS.PRIMARY_GREY_000};
  }
`
